import React from 'react'
import './ButtonExplore.css'

function ButtonExplore({btncontent}) {
  return (
    <button className='ButtonExploremain'>{btncontent}</button>
  )
}

export default ButtonExplore